import axiosInstance from './axios';

export const incomeService = {
  getIncomes: () => axiosInstance.get(`/api/incomesources`),
  createIncome: (data) => axiosInstance.post(`/api/incomesources`, {
    sourceType: data.sourceType,
    sourceName: data.sourceName,
    sourceDetails: data.sourceDetails,
    amount: data.amount,
    date: data.date
  }),
  updateIncome: (id, data) => axiosInstance.put(`/api/incomesources/${id}`, data),
  deleteIncome: (id) => axiosInstance.delete(`/api/incomesources/${id}`)
};
